// import Swiper JS
import Swiper from 'swiper';
import {Pagination, Navigation, Thumbs} from 'swiper/modules';
import {setFormData, uiLock} from '../module';
import * as CONST from '../constant';

//-----------------------------------
// Swiperを複製
//-----------------------------------
const $swiper = document.getElementById('slides');
const $thumbs = document.getElementById('thumbs');
const $swiperSlides = Array.from($swiper?.children || []).map((child) => child.cloneNode(true));
$swiperSlides.forEach(($swiperSlide) => {
  $thumbs?.appendChild($swiperSlide);
});

//-----------------------------------
// Swiper
//-----------------------------------
// thumbSliderを実行
const thumbSlider = new Swiper('#thumbSlider', {
  loop: true,
  modules: [Navigation],
  watchSlidesProgress: true,
  navigation: {
    nextEl: '.thumb-slider .swiper-button-next',
    prevEl: '.thumb-slider .swiper-button-prev',
  },
  breakpoints: {
    0: {
      slidesPerView: 6,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 6,
      spaceBetween: 10,
    },
  },
});

// 本体を実行
new Swiper('#deliverySlider', {
  loop: true,
  watchOverflow: true,
  modules: [Navigation, Thumbs, Pagination],
  navigation: {
    nextEl: '#deliverySlider .swiper-button-next',
    prevEl: '#deliverySlider .swiper-button-prev',
  },
  pagination: {
    el: '#deliverySlider .swiper-pagination',
    type: 'fraction',
    clickable: false,
  },
  thumbs: {
    swiper: thumbSlider,
  },
});

//-----------------------------------
// 削除
//-----------------------------------
document.querySelectorAll('.js-delete').forEach(($element) => {
  $element.addEventListener('click', (event: Event) => {
    const $this = event?.target as Element;
    const type = $this?.getAttribute('data-type');
    const id = $this?.getAttribute('data-id') || '';
    if (!type || isNaN(+id) || +id === 0) {
      alert(CONST.TXT_ERROR);
      return false;
    }
    if (!confirm(CONST.TXT_DELETE_CONFIRM)) {
      return false;
    }

    $this?.setAttribute('disabled', 'disabled');
    ($this as HTMLElement)?.blur();

    //-----------------------------------
    // 削除実行
    //-----------------------------------
    // UIロック
    uiLock();

    // データを取得
    const postData = new FormData();
    postData.set('action', 'updateDelivery');
    postData.set('method', 'delete');
    postData.set('update_id', id);
    // 入力値
    setFormData(postData, ['fetch', 'token']);

    // データを送信
    fetch(CONST.FETCH_URL, {
      method: 'post',
      body: postData,
      headers: CONST.FETCH_HEADERS,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (!data.success) {
          alert(CONST.TXT_ERROR);
          location.reload();
          return false;
        }
        alert(CONST.TXT_DELETE_COMPLETE);
        location.href = '/member/request/';
      })
      .catch(() => {
        alert(CONST.TXT_ERROR);
        location.reload();
        return false;
      });
  });
});

//-----------------------------------
// テーブルの中身に何もなければタグごと削除
//-----------------------------------
const $detailTable = document.querySelector('#detailTable table');
if ($detailTable && $detailTable.children.length === 0) {
  $detailTable.closest('#detailTable')?.remove();
}

//-----------------------------------
// お気に入りを切り替え
//-----------------------------------
document.querySelectorAll('.js-favorite')?.forEach(($element) => {
  $element.addEventListener('click', (event: Event) => {
    // 値を取得
    const $this = event?.target as Element;
    const type = $this?.getAttribute('data-type');
    let count = +($this as HTMLElement)?.innerText || 0;
    const id = $this?.getAttribute('data-id') || '';
    if (!type || isNaN(+id) || +id === 0) {
      alert(CONST.TXT_ERROR);
      return false;
    }

    // UIロック
    $this.setAttribute('disabled', 'disabled');
    ($this as HTMLElement)?.blur();

    // データを取得
    const postData = new FormData();
    postData.set('action', 'updateFavorite');
    postData.set('item_id', id);
    postData.set('type', type);

    // データを送信
    fetch(CONST.FETCH_URL, {
      method: 'post',
      body: postData,
      headers: CONST.FETCH_HEADERS,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (!data.success) {
          alert(CONST.TXT_ERROR);
          $this.removeAttribute('disabled');
          uiLock(false);
          return false;
        }

        // お気に入りを切り替え
        if (data.data.action === 1) {
          count++;
          // テキストを書き換え
          ($this as HTMLElement).innerText = String(count);
          $this.closest('.item-wrapper')?.setAttribute('favorite', '');
        } else if (data.data.action === 2) {
          count--;
          ($this as HTMLElement).innerText = String(count);
          $this.closest('.item-wrapper')?.removeAttribute('favorite');
        }
        setTimeout(() => {
          $this.removeAttribute('disabled');
        }, 1000);
      })
      .catch(() => {
        alert(CONST.TXT_ERROR);
        location.reload();
      });
  });
});

/**
 * execSort
 *
 * */
document.getElementById('execSort')?.addEventListener('change', (event) => {
  const $this = event?.target as HTMLInputElement;
  const value = $this.value;
  if (value === '') {
    return false;
  }

  (document.getElementById('narrow') as HTMLFormElement)?.submit();
});

/**
 * 閉じる
 *
 * */
document.getElementById('closeWindow')?.addEventListener('click', () => {
  window.opener = null;
  window.open('', '_self');
  window.close();
});
